<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!transaction">
      <span class="loader"></span>
    </span>
    <transaction-form
      v-if="transaction"
      :loading="loading"
      :transactionData="transaction"
      :formErrors="formErrors"
      @transactionSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import TransactionForm from "../partials/TransactionForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { TransactionForm },

  mixins: [alertLeave],

  props: {
    transactionId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      transaction: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "elixiopayTransactions/get",
          this.transactionId
        );
        this.transaction =
          this.$store.getters["elixiopayTransactions/elixiopayTransaction"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(transaction) {
      this.loading = true;
      const transactionData = cloneDeep(transaction);

      try {
        await this.$store.dispatch(
          "elixiopayTransactions/update",
          transactionData
        );
        this.$notify({
          type: "success",
          message: this.$t("NUVEI_CARDS.NUVEI_CARD_UPDATED"),
        });
        const transaction = await this.$store.getters[
          "elixiopayTransactions/elixiopayTransaction"
        ];
        this.$emit("onViewTransaction", transaction, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
